(function() {
    'use strict';

    angular
        .module('app')
        .controller('tsunShoppingCartController', tsunShoppingCartController);

    function tsunShoppingCartController($q, trainingInnerService, $uibModal, modalService, $rootScope) {
        var vm = this;
        vm.setTypeClass = setTypeClass;
        vm.openCourseModal = openCourseModal;
        vm.delCollection = delCollection;
        vm.enroll = enroll;
        //===Main===
        onInit();
        //==========
        function dataInit() {
            vm.data = {
                items: [],
            };
            vm.view = {
                isMobile: modalService.isMobile(), //.是否為行動裝置
                collectionEmpty: false, //............查無資料判定
                pageLoading: false, //................頁面讀取中
                pageLoaded: false, //.................頁面讀取完畢
            };
        }

        function logicInit() {
            //邏輯初始化。
            vm.view.pageLoading = true;
            return loadCollections()
                .then(function(collectionList) {
                    vm.data.items = collectionList || [];
                })
                .then(function() {
                    //finally
                    checkIsEmpty();
                    vm.view.pageLoading = false;
                    vm.view.pageLoaded = true;
                });
        }

        function onInit() {
            dataInit();
            logicInit();
        }

        function loadCollections() {
            //驗證課程收藏資料
            var courseCollection = trainingInnerService.getCollectionList();
            //取得所有課程資料
            var courseList = trainingInnerService.getCourseListAll();
            var resultSessionItems = [];
            return $q.all([courseCollection, courseList]).then(function(data) {
                //驗證課程收藏
                var dataCourseCollection = data[0];
                var dataCourseList = data[1];
                console.log("dataCourseList:", dataCourseList);
                _.forEach(dataCourseList, function(data) {
                    data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                });


                //console.log("courseColletion Raw:",dataCourseCollection);
                console.log("dataCourseList:", dataCourseList);
                _.forEach(dataCourseCollection, function(collectionItem) {
                    console.log("collectionItem:", collectionItem);
                    var findIndex = _.findIndex(dataCourseList, { sessionId: collectionItem.collectionSessionId });
                    if (findIndex >= 0) {
                        resultSessionItems.push(dataCourseList[findIndex]);
                    }
                    // return (findIndex >= 0);
                });
                // console.log("courseColletion result:",resultSessionItems);
                return resultSessionItems;
            });
        }

        function setTypeClass(type) {
            if (type === 'inClass') {
                return 'fa-book';
            }
            return 'fa-desktop';
        }

        function openCourseModal(item) {
            var modal = modalService.courseDetail(item);
            modal.result.then(function(data) {
                if (data) { enrollSuccess(item); }
            });
        }

        function delCollection(item) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", $rootScope.translate.tsunConfirmRemove, item.sessionName),
            });
            confirmDialog.result.then(function(result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                trainingInnerService.delCollection(item, true).then(function() {
                    remove(item);
                });
            });
        }

        function checkIsEmpty() {
            if (vm.data.items.length < 1) {
                vm.view.collectionEmpty = true;
            } else {
                vm.view.collectionEmpty = false;
            }
        }

        function remove(item) {
            var itemIndex = _.findIndex(vm.data.items, { sessionId: item.sessionId });
            if (itemIndex > -1) {
                vm.data.items.splice(itemIndex, 1);
            }
            checkIsEmpty();
        }

        function enrollSuccess(item) {
            trainingInnerService.delCollection(item, false).then(function() {
                remove(item);
            });
        }

        function enroll(item) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: $rootScope.translate.tsunEnrollInfoNoQuestion,
            });
            confirmDialog.result.then(function(result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                trainingInnerService.hasEnrollQuestion(item).then(function(result) {
                    if (!result) {
                        trainingInnerService.postSessionAction(item, 'Enroll')
                            .then(function(result) {
                                if (!result) { return; }
                                enrollSuccess(item);
                            });
                    } else {
                        var settingModel = {
                            isEnroll: true
                        };
                        var modal = modalService.courseDetail(item, settingModel);
                        modal.result.then(function(data) {
                            if (data) { enrollSuccess(item); }
                        });
                    }
                });
            });
        }
    }
})();